package main.kotlin.data

data class ItemUpdates(val error:String?=null,val data : Any?=null)